<template>
  <div id="maphome">
    <div id="headText">腾讯地图</div>
    <div id="mapcontent">
      <div id="myMap"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'mapTencent',
    data() {
      return {

      }
    },
    computed: {},
    mounted() {
      this.initLeaflet();
    },
    watch: {},
    methods: {
      initLeaflet() {
        var mymap = L.map('myMap', {
          center: [39.916042, 116.390694],
          zoom: 14,
          fullscreenControl: {
            pseudoFullscreen: true
          }
        });
        L.tileLayer('http://rt{s}.map.gtimg.com/realtimerender?z={z}&x={x}&y={y}&type=vector&style=0', {
          tms: true,
          attribution: '铿锵侠 &copy; 腾讯地图',
          maxZoom: 18,
          minZoom: 9,
          subdomains: "123"
        }).addTo(mymap);

      },
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #maphome {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url(../../../static/background.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    overflow-y: hidden;
  }

  #headText {
    color: white;
    margin: 50px;
    font-size: 20px;
  }

  #mapcontent {
    display: flex;
    justify-content: center;
  }

  #home-cartoon {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: -1;
  }

  #myMap {
    margin: 0 auto;
    height: 550px;
    width: 1200px;
  }

</style>



// WEBPACK FOOTER //
// mapTencent.vue?94d169b0